/** Same level display pattern as ConfigComparePage: CLUSTER | PILOT | PILOT.X | CLUSTER.X */
export function formatLevelDisplay(
  metadata: Record<string, any> | undefined,
  fallback = '—'
): string {
  if (
    !metadata ||
    (metadata.level == null &&
      metadata.levelDisplay == null &&
      (metadata as any).level_display == null)
  ) {
    return fallback;
  }
  const levelRaw = String(
    metadata?.level ?? (metadata as any)?.level_display ?? 'N/A'
  ).trim().toLowerCase();
  const displayPrefix = levelRaw === 'cluster' ? 'CLUSTER' : 'PILOT';
  const rawLevelDisplay =
    metadata?.levelDisplay ?? (metadata as any)?.level_display;
  const levelDisplayPart =
    rawLevelDisplay != null && String(rawLevelDisplay).trim() !== ''
      ? String(rawLevelDisplay).trim()
      : '';
  const levelDisplayPartLower = levelDisplayPart.toLowerCase();
  const isRedundant =
    levelDisplayPartLower === displayPrefix.toLowerCase() ||
    levelDisplayPartLower === levelRaw;
  return levelDisplayPart && !isRedundant
    ? `${displayPrefix}.${levelDisplayPart}`
    : displayPrefix;
}
